import { render } from "./IsoEvolveFooter.vue?vue&type=template&id=eac207ee&scoped=true"
import script from "./IsoEvolveFooter.vue?vue&type=script&lang=js"
export * from "./IsoEvolveFooter.vue?vue&type=script&lang=js"

import "./IsoEvolveFooter.vue?vue&type=style&index=0&id=eac207ee&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac207ee"]])

export default __exports__